import styled from 'styled-components';

export const HeaderContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: fixed;
  top: ${({ theme }) => theme.spacing.none};
  background: ${({ theme }) => theme.colors.darkBlue};
  z-index: 900;
`;

export const StyledMyAuditContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 100px ${({ theme }) => theme.spacing.m};
  margin-bottom: 88px;
  row-gap: ${({ theme }) => theme.spacing.m};
`;

export const FiltersContent = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
`;
